"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("styled-components");
const Logo = (props) => (react_1.default.createElement("img", { "data-testid": "logo", src: props.theme.logo, alt: "Brand Logo", className: props.className }));
exports.default = (0, styled_components_1.withTheme)(Logo);
